import Vue from 'vue';
import BootstrapVue from 'bootstrap-vue';
import axios from 'axios'
import VueAxios from 'vue-axios'
import router from './router';
import App from './App';
import Navigation from './components/modules/nav/nav';
import BottomFooter from './components/modules/bottom-footer/bottom-footer';
import InspirationModal from './components/modules/inspiration-modal/inspiration-modal';
import CustomerFinder from './components/modules/customer-finder/customer-finder';
import { POP as pop } from '@/http-common';

import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';

import '@/filters.js';
import Promise from 'promise-polyfill';

// To add to window
if (!window.Promise) {
    window.Promise = Promise;
}

Vue.config.productionTip = false;
Vue.use(BootstrapVue);
Vue.use(VueAxios, axios);
Vue.component('navigation', Navigation);
Vue.component('bottom-footer', BottomFooter);
Vue.component('inspiration-modal', InspirationModal);
Vue.component('customer-finder', CustomerFinder);

router.beforeEach((to, from, next) => {
    if (to.name === "login") {
        next();
        return;
    }

    axios.get('/api/user').then(function (response) {
        next();
    }).catch(e => {
        if (e.response.status === 401) {
            console.warn("NOT LOGGED IN", to, from, next);
            next('login');
        }
        else {
            next(e);
        }
    });
});

router.afterEach((to, from, next) => {
    window.scrollTo(0, 0);
});

/* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    template: '<App/>',
    components: { App },
    data: {
        system: {},
        spec: {}
    },
    created() {
        this.axios.get("/api/system").then((response) => {
            // console.log('system', response)
            this.system = response.data;
        }).catch((error) => {
            console.log(error)
        })
        /*this.axios.get("http://dev.pop-api.propertylogic.net/api/v1/specification", {
          withCredentials: false
        })*/
        pop.get('specification').then((response) => {
            // console.log(response)
            response.data.results.forEach((item) => {
                this.spec[item.specificationId] = item
            })
        }).catch((error) => {
            console.log(error)
        })
    }
})



// WEBPACK FOOTER //
// ./src/main.js